<template>
    <div
        class="review-widget-wrapper"
    >
        <h2>
            Would you like to save the details you give us?
        </h2>
        <p>Saving you details will help you finish services faster in the future.</p>
        <p>If you agree, the following personal information we collected today will be saved securely in your MyServiceNSW account:</p>
        <div
            v-for="(detail, index) in updatedDetails"
            :key="index"
            class="review-item"
        >
            <div class="update-detail-container">
                <label :for="'tuo-review-widget-' + detail.name">
                    <strong
                        class="mr-05"
                        :data-test="`checkbox-label-${'tuo-review-widget-' + detail.name}`"
                    >
                        {{ sentenceCase(detail.name) }}
                    </strong>
                    <span
                        :data-test="`checkbox-helper-${'tuo-review-widget-' + detail.name}`"
                    >
                        {{ typeof detail.value == 'object'?
                            detail.value.displayValue : detail.value }}
                    </span>
                </label>
            </div>
            <Badge
                :value="detail.type"
            />
        </div>
        <PiSecure/>
        <p>
            By selecting 'Save my details', you allow Service NSW to save and use your personal information.
        </p>
        <Accordion header="Learn how we use your personal information">
            <div class="accordion-body-subtitle">
                <strong class="mr-05">Types of information we collect and save:</strong>
            </div>
            <div class="column-layout">
                <div class="first-column-information-list">
                    <div>First name</div>
                    <div>Middle name</div>
                    <div>Family name</div>
                    <div>Date of birth</div>
                </div>
                <div class="second-column-information-list">
                    <div>Address</div>
                    <div>Mobile number</div>
                    <div>Driver licence card details</div>
                    <div>Medicare card details</div>
                </div>
            </div>
            <div class="accordion-body-subtitle">
                <strong class="mr-05 accordion-body-subtitle">How we user your information</strong>
            </div>
            <div>We pre-fill your personal details in forms that you complete online.</div>
            <div class="accordion-body-subtitle">
                <strong class="mr-05 accordion-body-subtitle">Services that may use your information</strong>
            </div>
            <ul>
                <li>Active Kids</li>
                <li>Creative Kids</li>
                <li>Seniors Energy Rebate</li>
                <li>Energy Switch</li>
            </ul>
            <p>
                Our
                <a
                    id="privacy-link"
                    class="is-internal"
                    href="https://www.service.nsw.gov.au/privacy"
                    target="_blank"
                    @click="triggerGA('Privacy Link', 'Click')"
                >
                    privacy statement
                </a> explains how we collect and use information.
            </p>
        </Accordion>
        <Button
            secondary
            data-test="save-update"
            :disabled="saveDisabled"
            @click="saveCustomerDetails"
        >
            Save my details
        </Button>
    </div>
</template>

<script>
    import Badge from '../components/Badge'
    import {sentenceCase} from 'change-case'
    import Button from "../components/Button"
    import PiSecure from "../components/PiSecure"
    import Accordion from "../components/Accordion"
    import gaTrackerAdapter from "../utils/gaTrackerAdapter"

    export default {
        name: 'UpdateDetailsSaveAll',
        components: {Button, Badge, Accordion, PiSecure},
        props: {
            updatedDetails: {
                type: Array,
                default: () => []
            },
            onSaveUpdate: {
                type: Function,
                default: () => {}
            },
        },
        data: () => ({
            saveDisabled: false,
        }),
        methods: {
            sentenceCase,
            selectAllClicked(checked) {
                this.noSelectionError = false
                this.updatedDetails.forEach(detail => {
                    detail.checked = checked
                })
            },
            saveCustomerDetails() {
                let detailsToSave = []

                this.updatedDetails.forEach(detail => detailsToSave.push(detail.name))

                this.saveDisabled = true

                this.onSaveUpdate(detailsToSave)
            },
            triggerGA(category, action, label = window.location.href) {
                gaTrackerAdapter.trackEvent(category,action, label)
            }
        }
    }
</script>
<style lang="css" src="../../node_modules/@servicensw/constants/constants.css"></style>
<style lang="css" scoped src="../../node_modules/@servicensw/base/dist/base.css"></style>
<style scoped lang="scss">
    .review-widget-wrapper {
        background: #f9f9f9;
        padding: 0 20px 25px 20px;
        margin-bottom: 30px;
        border-bottom: 1px solid silver;
        border-top: 1px solid silver;
    }

    .review-item {
        display: flex;
        align-items: baseline;
    }

    .is-internal {
        padding: 0;
    }

    h2 {
        margin-top: 2rem;
    }

    .update-detail-container {
        min-height: 50px;
        display: flex;
        align-items: center;

        label {
            display: flex;
            flex-direction: column;
        }
    }
    .first-column-information-list {
        line-height: 1.8rem;
    }

    .second-column-information-list {
        margin-left: 2rem;
        padding-left: 2rem;
        border-left: 1px solid silver;
        line-height: 1.8rem;
    }

    .column-layout {
        display: flex;
    }

    .accordion-body-subtitle {
        padding-top: 2rem;
        padding-bottom: 1rem;
        &:first-of-type {
            padding-top: 0;
        }
    }

    ul {
        margin-top: 0;
        margin-bottom: 0;
        li {
            padding: 0;
            background: none;
            font-size: 1rem;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
    }
</style>
